import type { ButtonHTMLAttributes } from "react";

import styles from "./IconButtonV2.module.css";

import {
  IconV2,
  type IconV2Name,
  type IconV2Size,
} from "@/components/atoms/IconV2";

export type IconButtonV2Color = "primary" | "error";
export type IconButtonV2Size = "xs" | "sm" | "md";

interface Props extends Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "onClick" | "disabled" | "type"
> {
  icon: IconV2Name;
  "aria-label": string;
  color?: IconButtonV2Color;
  size?: IconButtonV2Size;
  /** Hace girar el icono de forma continua. No deshabilita el botón. */
  spinning?: boolean;
}

const ICON_SCALE: Record<IconButtonV2Size, IconV2Size> = {
  xs: "xs",
  sm: "m",
  md: "l",
};

export const IconButtonV2 = ({
  icon,
  color = "primary",
  size = "md",
  type = "button",
  spinning = false,
  ...rest
}: Props) => (
  <button
    type={type}
    className={styles.button}
    data-color={color}
    data-size={size}
    data-spinning={spinning}
    {...rest}
  >
    <IconV2 name={icon} size={ICON_SCALE[size]} />
  </button>
);
